// extracted by mini-css-extract-plugin
export default {"container":"Interior_container__pkwgQ","text":"Interior_text__3g1Nr","info":"Interior_info__mJ7mp","img":"Interior_img__bjMMA"};